// extracted by mini-css-extract-plugin
export var btn = "HotelCardHorizontal-module--btn--243f0";
export var contentContainer = "HotelCardHorizontal-module--contentContainer--1bf4a";
export var heading = "HotelCardHorizontal-module--heading--2d476";
export var horizontal = "HotelCardHorizontal-module--horizontal--9914c";
export var image = "HotelCardHorizontal-module--image--8d1be";
export var link = "HotelCardHorizontal-module--link--22618";
export var secondary = "HotelCardHorizontal-module--secondary--41030";
export var star = "HotelCardHorizontal-module--star--9067c";
export var subheading = "HotelCardHorizontal-module--subheading--9e57d";